// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"703":"LazyIdentificationBusinessForm","886":"LazyInvitationStep","954":"LazyBusinessInfoFormComponent"}[chunkId] + "." + {"703":"6fe56ad8fcc229b74ef5","886":"7b568a8eb89900f67695","954":"d05bd9b070f55c52741e"}[chunkId] + ".css";
};